import React from "react";
import { MessageCircle } from "lucide-react";
import Modal from "src/components/ui/Modal";
import Button from "src/components/ui/Button";
import { SITE_SETTINGS } from "src/constants/common";

interface ContactSupportModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
}

const waLink = `https://wa.me/${SITE_SETTINGS.CONTACT_NUMBER.replace(/[^0-9]/g, "")}`;

const ContactSupportModal: React.FC<ContactSupportModalProps> = ({
  open,
  onClose,
  title = "Contact Support",
}) => {
  return (
    <Modal open={open} onClose={onClose} title={title}>
      <div className="space-y-4">
        <div className="space-y-2 text-sm text-gray-700">
          <p>Please reach out to support for plan renewal.</p>
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-center">
            <p className="mb-2 font-medium text-emerald-800">
              Chat with us for faster support
            </p>
            <a
              href={waLink}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1.5 rounded-full bg-emerald-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-emerald-700"
            >
              <MessageCircle size={16} />
              Chat with us
            </a>
          </div>
          <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
            <p className="font-medium text-gray-900">Email</p>
            <a
              href={`mailto:${SITE_SETTINGS.CONTACT_EMAIL}`}
              className="text-primary-600 hover:underline"
            >
              {SITE_SETTINGS.CONTACT_EMAIL}
            </a>
          </div>
          <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
            <p className="font-medium text-gray-900">Phone</p>
            <a
              href={`tel:${SITE_SETTINGS.CONTACT_NUMBER}`}
              className="text-primary-600 hover:underline"
            >
              {SITE_SETTINGS.CONTACT_NUMBER}
            </a>
          </div>
        </div>
        <div className="flex justify-end">
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ContactSupportModal;
